import axios from "axios";
import { blogPosts as staticBlogPosts } from "../Pages/PagesData/BlogPosts";

function apiBase() {
  const base = process.env.REACT_APP_API_URL || "";
  return base.replace(/\/$/, "");
}

/**
 * Lista posts desde MongoDB + archivos en servidor.
 * Si falla la API, usa el bundle estático (misma estructura).
 */
export async function fetchBlogPosts() {
  const url = `${apiBase()}/api/blog/posts`;
  try {
    const { data } = await axios.get(url, { timeout: 12000 });
    if (Array.isArray(data) && data.length > 0) {
      return data;
    }
  } catch (e) {
    console.warn("[blog] API no disponible, usando datos estáticos:", e.message);
  }
  return staticBlogPosts;
}

export async function fetchBlogPostBySlug(slug) {
  const url = `${apiBase()}/api/blog/posts/${encodeURIComponent(slug)}`;
  try {
    const { data } = await axios.get(url, { timeout: 12000 });
    return data;
  } catch (e) {
    console.warn("[blog] Detalle API fallback:", e.message);
    const local = staticBlogPosts.find((p) => p.slug === slug);
    return local || null;
  }
}

export async function fetchRecentBlogPosts(count = 3) {
  const all = await fetchBlogPosts();
  const sorted = [...all].sort((a, b) =>
    a.date < b.date ? 1 : a.date > b.date ? -1 : 0
  );
  return sorted.slice(0, count);
}
